import * as React from 'react';

import * as style from './Breadcrumbs.css';
import { IBreadcrumb } from '../../types/breadcrumb';

interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumb[];
}

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ breadcrumbs }) => {
  return (
    <div className={style['breadcrumbs']} data-testid="Breadcrumbs">
      {breadcrumbs.map((breadcrumb, index, arr) => {
        return (
          <span key={breadcrumb.title || index} className={style['breadcrumb']}>
            <a
              key={index}
              className={style['breadcrumbs-link']}
              href={breadcrumb.url || undefined}
              title={breadcrumb.title || ''}
            >
              <span>{breadcrumb.title}</span>
              {index < arr.length - 1 && <div className={style['breadcrumbs-delimiter']} />}
            </a>
          </span>
        );
      })}
    </div>
  );
};
